define('common/models/domain',['require','exports','module','backbone','env'],function (require, exports, module) {
  'use strict';

  var Backbone = require('backbone'),
    config = require('env');

  module.exports = Backbone.Model.extend({
    urlRoot: [config.apiHost, 'domains'].join('/'),
    defaults: {
      url: '',
      is_valid: false,
      is_valid_protocol: false,
    },
    initialize: function (options) {},
  });
});

